import Component from "@glimmer/component";
import { and, not, or } from "ember-truth-helpers";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { bool, number, oneOfType, shape, string } from "prop-types";
import { stringable } from "glesys-controlpanel/utils/prop-types";
import LinkItem from "glesys-controlpanel/components/entity/link-item";
import FoldOutItem from "glesys-controlpanel/components/entity/fold-out-item";
import StaticItem from "glesys-controlpanel/components/entity/static-item";

@forbidExtraArgs
export default class Entity extends Component {
  @arg(string.isRequired) title;
  @arg(string) key;
  @arg(string) route;
  @arg(oneOfType([string, number])) model;
  @arg(stringable) linkLabel;
  @arg(shape({ state: string.isRequired, color: string, showSpinner: bool, labelKey: string })) status;
  @arg(shape({ color: string, label: stringable })) workflowState;
  @arg(bool) managedHosting = false;
  @arg(bool) hideActions = false;

  get entityKey() {
    return this.key ?? this.title;
  }

  <template>
    {{#let
      (if this.route LinkItem (if (has-block "details") FoldOutItem StaticItem))
      (and (has-block "actions") (not this.hideActions))
      (or this.status (has-block "fields"))
      as |Item hasActions hasFields|
    }}
      <Item
        data-test-entity={{this.entityKey}}
        @route={{this.route}}
        @model={{this.model}}
        @linkLabel={{this.linkLabel}}
        @title={{this.title}}
        @key={{this.key}}
        @workflowState={{this.workflowState}}
        @managedHosting={{this.managedHosting}}
        @status={{this.status}}
        @hasActions={{hasActions}}
        @hasFields={{hasFields}}
        ...attributes
      >
        <:fields>
          {{yield to="fields"}}
        </:fields>
        <:actions>
          {{yield to="actions"}}
        </:actions>
        <:details>
          {{yield to="details"}}
        </:details>
      </Item>
    {{/let}}
  </template>
}
